import styled from 'styled-components'

export const YourPlansWrapper = styled.div`
  padding: 2rem 1rem;
  @media (min-width: 1024px) {
    padding: 73px 66px 50px 66px;
  }
`

export const FlexContainer = styled.div`
  max-width: 650px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  flex-wrap: wrap;
`

export const DataWrapper = styled.div`
  min-width: 128px;
  background-color: #e9ecef;
  font-size: 18px;
  color: var(--primary);
  margin-right: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
  margin-bottom: 24px;
  padding: 1rem;
`
